import { useDispatch } from "react-redux";
import { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import EditIcon from '@mui/icons-material/Edit';

import PartImage from "../../assets/images/part-thumbnail.svg";
import ErrorIcon from "../../assets/images/error-icon.svg";
import ProgressIcon from "../../assets/images/progress.svg";
import AvailableIcon from "../../assets/images/availbale.svg";
import NotAvailableIcon from "../../assets/images/notavailable.svg";
import { AppDispatch } from "../../redux/store/store";
import { selectPart } from "../../redux/features/partSlice";
import "./PartCardView.scss";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  deletePart
} from "../../services/part/partService";

interface PartProps {
  displayPart: {
    CreatedAt: string;
    UpdatedAt: string;
    ModelType: string;
    Processed: Record<string, string> | null;
    PartName: string;
    Username?: string;
    icon?: string;
    PartID: number;
  };
  onSelectPart: (part: any, type: string) => void;
  handleDownload: () => void;
  onOrder: () => void;
  loggedInUser?: string;
  isAdmin?: boolean;
}

const PartsCardView = (props: PartProps) => {
  const { CreatedAt, UpdatedAt, ModelType, Processed } = props.displayPart;
  const dispatch = useDispatch<AppDispatch>();
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [openResultPopup, setOpenResultPopup] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = () => {
    //dispatch(selectPart({ partName: props.displayPart, partId: "12" }));
    //if (ModelType === "stl") props.onSelectPart(props.displayPart, "edit");
    dispatch(
      selectPart({
        partName: props.displayPart,
        partId: "12"
      })
    );
  
    props.onSelectPart(
      props.displayPart,
      "edit"
    );
  };
  

  const handleDownload = () => {
    props.handleDownload();
  };

  const handleOrder = () => {
    props.onOrder();
  };

  const confirmDelete = async () => {

    try {
  
      const response =
        await deletePart(
          props.displayPart.PartID
        );
  
      if (response.ok) {
  
        setOpenDeletePopup(false);
  
        window.location.reload();
  
      } else {
  
        alert(
          "Failed to delete part"
        );
      }
  
    } catch (err) {
  
      console.error(err);
  
      alert(
        "Delete failed"
      );
    }
  };

  const handleViewResults = () => {

    dispatch(
      selectPart({
        partName: props.displayPart,
        partId: "12"
      })
    );
  
    props.onSelectPart(
      props.displayPart,
      "edit"
    );
  };

  const handleDeletePart = () => {
    setOpenDeletePopup(true);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuAction = (action: string) => {
    console.log('Menu action:', action);
    handleMenuClose();
    // Add your logic here for each menu action
  };

  return (
    <>
      <Popover
        id="part-menu"
        open={menuOpen}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              minWidth: 200,
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
            },
          },
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              handleDeletePart();
            }}
          >
            Delete
          </MenuItem>
        </MenuList>
      </Popover>

      <div className="display-card" style={{ paddingLeft: "10px" }}>
        <div className="img-col plate-thumb" onClick={handleClick}>
          {props?.displayPart?.icon ? (
            <img
              src={props.displayPart.icon}
              alt="part-thumbnail"
              className="thumbnail-img plate-thumbnail"
            />
          ) : (
            <img
              src={PartImage}
              className="thumbnail-img plate-thumb"
              alt="part-thumbnail"
            />
          )}
        </div>

        <div className="display-card-row pt-0">
          <div className="display-card-header d-flex justify-content-between">
            <label>{props.displayPart.PartName}</label>
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
              {!Processed || Object.keys(Processed).length === 0 ? (
                <span className="d-flex">
                  <img src={NotAvailableIcon} alt="Not Available" width={20} />
                </span>
              ) : Processed.error_msg ? (
                <span className="d-flex">
                  <img src={ErrorIcon} alt="Error" width={20} />
                </span>
              ) : Object.values(Processed).includes("False") ? (
                <span className="d-flex">
                  <img src={ProgressIcon} alt="Processing" width={20} />
                </span>
              ) : (
                <span className="d-flex">
                  <img src={AvailableIcon} alt="Available" width={20} />
                </span>
              )}
              <>
                <IconButton
                  aria-label="more"
                  aria-controls={menuOpen ? 'part-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={menuOpen ? 'true' : undefined}
                  onClick={handleMenuClick}
                  size="small"
                  sx={{ padding: '4px' }}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </>
            </div>
          </div>

          <div className="details">
            <label>Model Type:</label>
            <span className="data-format">{ModelType}</span>
          </div>
          <div className="details">
            <label>Created at:</label>
            <span className="data-format">
              {new Date(CreatedAt).toDateString()},{" "}
              {new Date(CreatedAt).toLocaleTimeString()}
            </span>
          </div>
          <div className="details">
            <label>Updated at:</label>
            <span className="data-format">
              {new Date(UpdatedAt).toDateString()},{" "}
              {new Date(UpdatedAt).toLocaleTimeString()}
            </span>
          </div>

          {/*<div className="details">
            <label>Results:</label>

            <span className={`status-badge ${Processed && Object.keys(Processed).length > 0 && !Processed.error_msg && !Object.values(Processed).includes("False") && !Object.values(Processed).includes("Error") ? 'available' : 'not-available'}`}>
              <span className="status-dot"></span>
              {Processed && Object.keys(Processed).length > 0
                ? Processed.error_msg
                  ? "Error"
                  : Object.values(Processed).includes("False")
                  ? "Processing"
                  : Object.values(Processed).includes("Error")
                  ? "Error"
                  : "Available"
                : "Not Available"}
            </span>
              </div>*/}

          {props.isAdmin && (
            <div className="details">
              <label>Created By:</label>
              <span className="data-format">
                {props.loggedInUser || props.displayPart.Username || 'N/A'}
              </span>
            </div>
          )}

          <div className="card-actions">
            
              

              <>
                {props.isAdmin ? (
                  <div
                    className="icon result view-result-label"
                    onClick={handleViewResults}
                    style={{ margin: '0 auto' }}
                  >
                    <VisibilityIcon sx={{ width: '20px!important', height: '20px!important' }} /> Estimate
                  </div>
                ) : (
                  <>
                    <div
                      className="icon result view-result-label"
                      onClick={handleViewResults}
                      style={{ margin: '0 auto' }}
                    >
                      <VisibilityIcon sx={{ width: '20px!important', height: '20px!important' }} /> Estimate
                    </div>
                    {/*<div className="icon download" onClick={handleOrder} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <ShoppingCartIcon sx={{ width: '20px!important', height: '20px!important' }} />
                      Order
                    </div>
                    <div className="icon delete" onClick={handleClick} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <EditIcon sx={{ width: '20px!important', height: '20px!important' }} />
                      Edit
                </div>*/}
                  </>
                )}
              </>
            
          </div>
        </div>
      </div>

      {/* Delete Part Modal */}
      <Modal
        show={openDeletePopup}
        onHide={() => setOpenDeletePopup(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Part</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOpenDeletePopup(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={confirmDelete}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Result Modal */}
      <Modal
        show={openResultPopup}
        onHide={() => setOpenResultPopup(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Estimate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Processed?.error_msg ? (
            <p className="text-danger fs-6">{Processed.error_msg}</p>
          ) : (
            <p>No additional information available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setOpenResultPopup(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PartsCardView;
